export const iconFontAwesomeHandsHandsPraying = (
	<i className="fa-solid fa-hands-praying"></i>
);
